var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProDocIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.89111V5.33323C11.6667 5.79994 11.6667 6.0333 11.7575 6.21156C11.8374 6.36836 11.9649 6.49584 12.1217 6.57574C12.3 6.66656 12.5333 6.66656 13 6.66656H16.4422M13.3334 10.8332H6.66671M13.3334 14.1665H6.66671M8.33337 7.49984H6.66671M11.6667 1.6665H7.33337C5.93324 1.6665 5.23318 1.6665 4.6984 1.93899C4.22799 2.17867 3.84554 2.56112 3.60586 3.03153C3.33337 3.56631 3.33337 4.26637 3.33337 5.6665V14.3332C3.33337 15.7333 3.33337 16.4334 3.60586 16.9681C3.84554 17.4386 4.22799 17.821 4.6984 18.0607C5.23318 18.3332 5.93324 18.3332 7.33337 18.3332H12.6667C14.0668 18.3332 14.7669 18.3332 15.3017 18.0607C15.7721 17.821 16.1545 17.4386 16.3942 16.9681C16.6667 16.4334 16.6667 15.7333 16.6667 14.3332V6.6665L11.6667 1.6665Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProDocIcon);
export default __webpack_public_path__ + "static/media/pro-doc-icon.5f886f5e8d518b9623b6346a07bc1bc9.svg";
export { ForwardRef as ReactComponent };